module.exports = __webpack_public_path__ + "img/sta_open.aa19583c.png";